import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { HucuService } from '../hucu.service';
import { SprintModel } from 'src/app/shared/model/gestion-proyectos/sprint';
import swal from 'sweetalert2';
import { ReplaySubject } from 'rxjs';
import { Etapa } from 'src/app/shared/model/gestion-proyectos/etapa/etapa';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { EstatusSprint, EstatusSprintEnum } from 'src/app/utilerias/enums/estatusSprintEnum';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSelect } from '@angular/material/select';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';

@Component({
    selector: 'app-modal-sprint',
    templateUrl: './modal-sprint.component.html',
    styleUrls: ['./modal-sprint.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, CdkScrollable, MatDialogContent, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatSelect, NgFor, MatOption, NgIf, MatButton, AsyncPipe]
})
export class ModalSprintComponent {

  objectSprint: SprintModel;
  listStage: Array<Etapa>;
  public filterStage: ReplaySubject<Etapa[]> = new ReplaySubject<Etapa[]>(1);
  listSprint: Array<SprintModel>;
  public filterSprint: ReplaySubject<SprintModel[]> = new ReplaySubject<SprintModel[]>(1);
  datosform: FormGroup;
  esModificar: boolean;
  estatus = Object.keys(EstatusSprintEnum).map(estatus => ({
    estatus, value: EstatusSprintEnum[estatus],
    estatusConvertido: EstatusSprint.eliminarGuion(estatus)
  }));
  minDateFin = new Date();
  consultaObject = new ConsultaList<SprintModel>();
  listSprints: Array<SprintModel>;
  estatusProceso: boolean;

  constructor(
    public dialogRef: MatDialogRef<ModalSprintComponent>,
    private formbuilder: FormBuilder,
    private hucuService: HucuService,
    private serviceProyecto: ProyectosService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private msg: Msg
  ) { }

  ngOnInit() {
    if (this.data.sprint !== null) {
      this.objectSprint = this.data.sprint;
      this.objectSprint.idProyecto = this.data.proyecto.id;
      this.onSelectEtapa(this.objectSprint);
      this.esModificar = true;
      this.estatusProceso = this.objectSprint.estatus == EstatusSprintEnum.EN_PROCESO ? true : false;
    } else { 
      this.objectSprint = new SprintModel();
      this.objectSprint.idProyecto = this.data.proyecto.id;
    }

    this.stageConsultation(this.data.proyecto.id);

    this.datosform = this.formbuilder.group({
      nombre: ['',  [Validators.required]],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      etapa: ['', [Validators.required]],
      sprintAnterior: [''],
      estatus: ['']
    });

    this.datosform.get("fechaInicio").valueChanges.subscribe(valor => {
      if(valor){
        const fechaInicio = new Date(this.datosform.get('fechaInicio').value);
        this.minDateFin.setDate(fechaInicio.getDate() + Constantes.UNO);
      }
      });
  }

  saveSprint(): void {
    this.objectSprint.idProyecto= this.data.proyecto.id;
    this.hucuService.saveSprint(this.objectSprint).subscribe(
      (respuesta) => {
        swal.fire({
          text: 'Sprint registrado exitosamente',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          icon: 'success',
        }).then((result) => {
          this.dialogRef.close(true);
        });
      }
    );
  }

  stageConsultation(id: number) {
    // this.iService.consultaetapas(id).subscribe(res => {
      this.listStage = this.data.proyecto.etapas;
      this.filterStage.next(this.listStage.slice());
    // });
  }

  onSelectEtapa(event: any): void {
    this.hucuService.consultaSprint(this.objectSprint).subscribe((res: any) => {
      this.filterSprint.next(res.filter(sprint => sprint.id !== this.objectSprint.id));
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  validarFechaInicio(fecha){
    const fechaValida = new Date(fecha.value);
    if(!this.validacionFinSemana(fechaValida)){
      this.datosform.get("fechaInicio").setValue(null);
    }
  }
  
  validaFechaFin(fecha){
    const fechaValida = new Date(fecha.value)
    if(!this.validacionFinSemana(fechaValida)){
      this.datosform.get("fechaFin").setValue(null);
    }
  }
  
  validacionFinSemana(fecha: any) {
    if(fecha.getDay() !== 0 && fecha.getDay() !== 6){
        return true;
    }else{
        this.msg.errorCall("No puedes seleccionar un fin de semana", null, null);
        return false;
    }
  }

  validarEstatusSprint(estatusSeleccionado: any){
    if(estatusSeleccionado == EstatusSprintEnum.EN_PROCESO && !this.estatusProceso){
    this.consultaObject.bean = new SprintModel();
    this.consultaObject.sort = 'id';
    this.consultaObject.param4 = Constantes.UNO;
    this.consultaObject.param7=this.data.proyecto.id;
    this.serviceProyecto.consultaSprintPaginacion(this.consultaObject).subscribe(res => {
        this.listSprints = res.list;
        this.listSprints.forEach((sprint, i) => {
          if (this.listSprints[i].estatus == EstatusSprintEnum.EN_PROCESO) {
            this.datosform.get('estatus').setValue(undefined);
            this.msg.warningCall("Ya existe un sprint en proceso, elige otro estatus.", null, null);
          }
          });
    });
  }
  }

}
